const T_TRAVEL_DOMAINS = ["t-travel.ru", "tbank.ru", "tinkoff.ru"];

export function isTTravelHostname(hostname: string): boolean {
  const normalized = hostname.toLowerCase();
  return T_TRAVEL_DOMAINS.some(
    (domain) => normalized === domain || normalized.endsWith(`.${domain}`),
  );
}
